import * as React from 'react';
/**
 *
 * Original name: sort type
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1009
 *
 */
export const SortTypeLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M16.5 11.5c-2.322 0-3.5 1.178-3.5 3.5 0 2.323 1.178 3.5 3.5 3.5 2.323 0 3.5-1.177 3.5-3.5 0-2.322-1.177-3.5-3.5-3.5Zm0 5.5c-1.476 0-2-.523-2-2 0-1.476.524-2 2-2 1.477 0 2 .524 2 2 0 1.477-.523 2-2 2Zm-13 1.5H10V12H3.5v6.5Zm1.5-5h3.5V17H5v-3.5Zm2.912-8L12 12.188 16.087 5.5H7.912ZM10.588 7h2.825L12 9.312 10.588 7Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
